import React from "react"
import cardHOC from "./carHOC"
import teamsPlusLogo from "../../images/teamsplus-logo.svg"
import studentGroupPicture from "../../images/student-group.png"

const TeamsPlusHeading: React.FC = () => {
  return (
    <img style={{ height: "40px" }} src={teamsPlusLogo} alt="teamsplus logo" />
  )
}

const TeamsPlusCardTemplate = cardHOC(TeamsPlusHeading)

const TeamsPlusCard: React.FC<{ className: string }> = (props) => {
  return (
    <TeamsPlusCardTemplate
      heading="Enhance people capability with"
      imgSrc={studentGroupPicture}
      content="Drive continuous learning, compliance and capability with our Learning Experience Platform (LXP)"
      className={props.className}
      activeColor="#393DE3"
      path="/solutions/teamsplus"
      linkLabel="More about TeamsPlus"
    />
  )
}

export default TeamsPlusCard
